import { createClient } from "@supabase/supabase-js";

import { env } from "@/lib/env";

/**
 * Supabase istemcisi — YALNIZCA kimlik doğrulama için.
 *
 * Veri erişimi axios üzerinden PostgREST'e gidiyor (bkz. lib/http.ts). Bu ayrımın
 * nedeni supabase-js'in oturum yönetimini kendi başımıza yazmak istememek:
 * jetonun yenilenmesi, sekmeler arası eşitleme ve depolamadan geri yükleme
 * doğru yapılması zor işler. Veri katmanında ise axios'un kesicileri (retry,
 * tek biçimli hata, oturum sonlanınca çıkış) tek yerde toplanabiliyor.
 *
 * Realtime kapalı: uygulamada canlı güncelleme gerektiren bir ekran yok,
 * açık bırakmak her sekmede gereksiz bir WebSocket demek olurdu.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: "ebridge-lisans-auth",
  },
  global: {
    headers: { "x-application-name": "ebridge-lisans-web" },
  },
});

/** Geçerli erişim jetonu; oturum yoksa null. */
export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
